import TaxiIcon from "./TaxiIcon";

// Compact account-screen primitives: one row that reveals its own body, plus the
// label/value and status-chip shapes every section uses, so the whole profile
// reads as a single style instead of a stack of differently headed cards.

export const Disclosure = ({ id, icon, title, hint, tone, open, onToggle, children, tour }) => (
  <section className={`glass rounded-2xl taxi-acc ${open ? "is-open" : ""}`}>
    <button
      type="button"
      className="taxi-acc-head press"
      aria-expanded={open}
      aria-controls={`${id}-body`}
      data-tour={tour}
      onClick={onToggle}
    >
      <span className="taxi-acc-icon"><TaxiIcon name={icon} size={19} /></span>
      <span className="taxi-acc-titles">
        <span className="taxi-acc-title">{title}</span>
        {hint && (
          <span className={`taxi-acc-hint${tone ? ` is-${tone}` : ""}`}>{hint}</span>
        )}
      </span>
      <TaxiIcon name="down" size={18} className="taxi-acc-chevron" />
    </button>
    {open && (
      <div id={`${id}-body`} className="taxi-acc-body anim-rise">
        {children}
      </div>
    )}
  </section>
);

export const Kv = ({ label, value, tone }) => (
  <div className="taxi-kv">
    <span className="taxi-kv-label">{label}</span>
    <span className={`taxi-kv-value${tone ? ` is-${tone}` : ""}`}>
      {value === null || value === undefined || value === "" ? "—" : value}
    </span>
  </div>
);

export const Chip = ({ children, tone }) => (
  <span className={`taxi-chip${tone ? ` is-${tone}` : ""}`}>{children}</span>
);

export default Disclosure;
